export default {
    instructionCenter: {
        title: 'AI 指令庫',
        searchPlaceholder: '搜尋指令...',
        gridView: '網格視圖',
        listView: '列表視圖',
        createInstruction: '建立指令',
        noInstructions: '暫無指令',
        noInstructionsDesc: '點擊「建立指令」按鈕添加您的第一個指令',
        loading: '載入中',
        loadMore: '載入更多',
        preview: '預覽',
        edit: '編輯',
        delete: '刪除',
        cancel: '取消',
        save: '保存',
        saving: '保存中',
        moreActions: '更多操作',
        editInstruction: '編輯指令',
        addFavorite: '收藏',
        removeFavorite: '取消收藏',
        noResults: '未找到指令',

        // Select Dialog
        selectDialog: {
            title: '從庫中選擇',
            forSection: '用於章節',
        },

        // Technology Area
        technologyArea: {
            general: '通用',
            electrical: '電氣',
            mechanical: '機械',
            chemical: '化學',
            software: '軟體',
        },

        // Section
        section: {
            title: '標題',
            background: '背景',
            summary: '發明內容',
            briefFigures: '附圖簡述',
            claims: '權利要求',
            abstract: '摘要',
            detailed: '詳細描述',
            detailedPlan: '詳細描述計劃',
            repeatClaims: '重複權利要求',
            custom: '自訂',
            USC_101: '35 U.S.C. § 101',
            USC_102: '35 U.S.C. § 102',
            USC_103: '35 U.S.C. § 103',
            USC_112A_ENABLEMENT: '35 U.S.C. § 112(a) 可實施性',
            USC_112A_WRITTEN_DESCRIPTION: '35 U.S.C. § 112(a) 書面描述',
            USC_112B: '35 U.S.C. § 112(b)',
            CLAIM_OBJECTION: '權利要求異議',
            DRAWING_OBJECTION: '附圖異議',
            SPECIFICATION_OBJECTION: '說明書異議',
            DOUBLE_PATENTING: '雙重專利',
            PRIORITY_CLAIM: '優先權主張',
            RESTRICTION_REQUIREMENT: '限制要求',
            INFORMATION_DISCLOSURE: '資訊揭露聲明',
        },

        // Filter
        filter: {
            title: '篩選',
            region: '地區',
            type: '類型',
            from: '來源',
            myInstructions: '我的指令',
            library: '指令庫',
            clear: '清除 {count} 個篩選',
        },

        // Tabs
        tabs: {
            all: '全部',
            title: '標題',
            abstract: '摘要',
            background: '背景',
            summary: '發明內容',
            claims: '權利要求',
            detailedDescription: '具體實施方式',
            officeActionResponse: '審查意見答覆',
            myInstructions: '我的指令',
            sharedInstructions: '分享的指令',
            favorites: '收藏',
        },

        // Pills
        pills: {
            all: '全部指令',
            my: '我的指令',
            official: '官方指令',
            shared: '分享的指令',
            favorites: '收藏',
        },

        // Sections
        sections: {
            title: '標題',
            abstract: '摘要',
            background: '背景技術',
            summary: '發明內容',
            briefFigures: '附圖說明',
            claims: '權利要求書',
            detailed: '具體實施方式',
            custom: '自定義',
        },

        // Instruction Types
        instructionTypes: {
            patentApplication: '專利申請',
            inventionDisclosure: '發明披露',
            officeActionResponse: '審查意見答覆',
        },

        // Sources
        sources: {
            system: '系統',
            custom: '自定義',
            library: '指令庫',
        },

        // Dialog
        dialog: {
            name: '指令名稱',
            namePlaceholder: '請輸入指令名稱',
            instructionType: '指令類型',
            templateSection: '模板章節',
            selectSection: '請選擇模板章節',
            description: '描述',
            descriptionPlaceholder: '請輸入描述信息（可選）',
            descriptionHint: '簡要描述這條指令的用途和特點',
            content: 'AI 指令內容',
            contentPlaceholder: '請輸入 AI 指令內容，這將指導 AI 如何生成內容...',
            contentHint: '詳細描述 AI 應該如何處理和生成內容，包括風格、格式、重點等要求',
            advancedSettings: '高級設置',
            region: '地區',
            technologyArea: '技術領域',
            optional: '可選',
            quickSettings: '快速設置',
            requiredFieldsHint: '* 表示必填項',
            fillBasicInfo: '填寫基本信息以創建新指令',
            updateHint: '更新指令信息',
            viewOnlyHint: '查看系統指令詳情（只讀模式）',
            unsavedChangesTitle: '未儲存的修改',
            unsavedChangesMessage: '您有未儲存的修改，確定要關閉嗎？關閉後修改將遺失。',
            discardChanges: '放棄修改',
            continueEditing: '繼續編輯',
            systemReadOnlyHint: '系統指令為只讀，無法編輯',
            readOnlyPermissionHint: '您只有唯讀權限，無法編輯此指令',
            close: '關閉',

            // Level selection (Super Admin only)
            level: '可見性',
            adminOnly: '僅管理員',
            systemLevel: '系統級',
            userLevel: '用戶級',
        },

        // Messages
        messages: {
            saveFailed: '保存失敗',
            fetchListFailed: '獲取指令列表失敗',
            fetchDetailFailed: '獲取指令詳情失敗',
            createSuccess: '建立成功',
            createFailed: '建立失敗',
            updateSuccess: '更新成功',
            updateFailed: '更新失敗',
            deleteSuccess: '刪除成功',
            deleteFailed: '刪除失敗',
            addFavoriteSuccess: '收藏成功',
            removeFavoriteSuccess: '取消收藏成功',
            favoriteOperationFailed: '收藏操作失敗',
            shareSuccess: '分享成功',
            shareFailed: '分享失敗',
            fetchSharesFailed: '獲取分享列表失敗',
            updateShareSuccess: '更新分享成功',
            updateShareFailed: '更新分享失���',
            deleteShareSuccess: '刪除分享成功',
            deleteShareFailed: '刪除分享失敗',
        },

        // Share
        share: {
            title: '分享',
            shareType: '分享類型',
            company: '公司',
            companyShareName: '本公司',
            personal: '個人',
            permission: '權限',
            read: '唯讀',
            write: '讀寫',
            sharedTo: '分享給',
            expiresAt: '過期時間',
            neverExpires: '永不過期',
            expiry7Days: '7天',
            expiry15Days: '15天',
            expiry30Days: '30天',
            shareList: '分享列表',
            noShares: '暫無分享記錄',
            confirmDelete: '確認刪除此分享記錄？',
            cannotShareSystem: '系統指令不允許分享',
            cannotShareOthers: '只能分享自己建立的指令',
            enterUserId: '請輸入用戶ID',
            viewShareList: '查看分享列表',
            createNew: '建立分享',
            companyShareDesc: '公司內所有成員都可以訪問此指令',
            personalShareDesc: '僅指定用戶可以訪問此指令',
        },
    },
};
